import React from "react";

import AreasList from "../Modal/AreasList";
import Context from "../../../context/Context";
//import { ModalController } from "../Modal";
import { ModalController } from "../../../common/components/Modal";
import * as assignPrompt from "./assignPrompt";
import * as component from "../../../components/util/component";

import { CalciteP } from "calcite-react/Elements";
import { Container } from "../../styles/Common/selectArea";

export default class SelectArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = component.newState({});
  }

  componentDidMount() {}

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  onSelectionChanged = selected => {
    if (this.props.onSelectionChanged) {
      this.props.onSelectionChanged(selected);
    }
  };

  render() {
    const prompt = assignPrompt.getPrompt(this.props.promptOptions);
    return (
      <Container>
        <CalciteP>{prompt.text}</CalciteP>
        <AreasList
          areaType={this.props.areaType}
          handleSelection={this.onSelectionChanged}
        />
      </Container>
    );
  }

  static showModal(props) {
    let content, controller, okButton, selected;

    const onOK = obj => {
      if (props && props.onOK) {
        props.onOK(selected);
      }
    };

    let selectProps = {
      areaType: props && props.areaType,
      promptOptions: props && props.promptOptions,
      onSelectionChanged: sel => {
        selected = sel;
        if (okButton) {
          if (sel) okButton.enable();
          else okButton.disable();
        }
      }
    };

    let modalProps = {
      title: props && props.title,
      okLabel: Context.instance.i18n.spaceplanner.buttonLabel.assign,
      showOKCancel: true,
      onOK: onOK,
      dialogStyle: { height: "65vh", width: "35vw" }
    };
    modalProps.onMountOKButton = btn => {
      okButton = btn;
      okButton.disable();
    };

    content = <SelectArea {...selectProps} />;
    controller = new ModalController({});
    controller.show(modalProps, content);
  }
}
